import { call, put } from "redux-saga/effects";
import { create, deleteRec, downloadTemp, find, search, uploadData } from "./clientService";
import { createModule } from "saga-slice";

const clientSlice = createModule({
    name: "client",
    initialState: {
        clients: [],
        isFetching: false,
        error: null,
        total:0
    },
    reducers: {
        downloadTemp: (state) => {
            state.isFetching = true;
        },
        find: (state) => {
            state.isFetching = true;
        },
        create: (state) => {
            state.isFetching = true;
        },
        search: (state) => {
            state.isFetching = true;
        },
        uploadData: (state) => {
            state.isFetching = true;
        },
        delete: (state) => {
            state.isFetching = true;
        },
        fetchSuccess: (state, payload) => {
            state.clients = payload.body.content;
            state.total = payload.body.totalElements;
        },
        finishFetching: (state) => {
            state.isFetching = false;
        },
        fetchError: (state) => {
            state.isFetching = false;
            state.error = "An error occured";
        },
    },
    sagas: (A) => ({
        *[A.downloadTemp]({ payload }) {
            try {
                const { data } = yield downloadTemp(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError, e);
            }
        },
        *[A.uploadData]({ payload }) {
            try {
                const { data } = yield uploadData(payload.formData);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
                if (payload.onError) yield call(payload.onError, e);
            }
        },
        *[A.delete]({ payload }) {
            try {
                yield deleteRec(payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.create]({ payload }) {
            try {
                yield create(payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.find]({ payload }) {
            try {
                const { data } = yield find(payload.id);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data.body);
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        
        *[A.search]({ payload }) {
            try {
                const { data } = yield search(payload);
                yield put(A.finishFetching());
                yield put(A.fetchSuccess(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
    })
})

export default clientSlice;
export const clientActions = clientSlice.actions;
